module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-toolbar', {
    staticClass: "filter-bar",
    attrs: {
      "color": "white",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn-toggle', {
    staticClass: "no-shadow",
    attrs: {
      "mandatory": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white",
      "value": "all"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('filterUsers', 'all')
      }
    }
  }, [_vm._v("All")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white",
      "value": "newest"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('filterUsers', 'newest')
      }
    }
  }, [_vm._v("Newest")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white",
      "value": "admins"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('filterUsers', 'admins')
      }
    }
  }, [_vm._v("Admins")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white",
      "value": "consultants"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('filterUsers', 'consultants')
      }
    }
  }, [_vm._v("Clients")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white",
      "value": "clients"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('filterUsers', 'clients')
      }
    }
  }, [_vm._v("Customers")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "white",
      "value": "disabled"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('filterUsers', 'disabled')
      }
    }
  }, [_vm._v("Disabled")])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "value": _vm.search,
      "single-line": "",
      "hide-details": "",
      "append-icon": "search",
      "flat": "",
      "clearable": ""
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('search', _vm.searchFor)
      },
      "click:clear": function($event) {
        return _vm.$emit('search', '')
      }
    },
    model: {
      value: (_vm.searchFor),
      callback: function($$v) {
        _vm.searchFor = $$v
      },
      expression: "searchFor"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "pr-4"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d96b792","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/users/filter-bar.vue
// module id = 655
// module chunks = 1